
import { useState, useRef, useEffect, useContext } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, EffectFade } from 'swiper'
import classNames from 'classnames'

import { AnnouncementContext } from './context/announcementContext'

import 'swiper/scss'
import 'swiper/scss/autoplay'
import 'swiper/scss/effect-fade'

import styles from './front_hero.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Media from './basic/media'

function updateTicker(currentIndex){
	const tickers = document.getElementsByClassName(styles.ticker_slide)
	const tickerLength = tickers.length
	let previousIndex = currentIndex - 1
	let nextIndex = currentIndex + 1

	if(previousIndex < 0){
		previousIndex = tickerLength - 1
	}

	if(nextIndex == tickerLength){
		nextIndex = 0
	}

	if(tickers[currentIndex]){
		tickers[currentIndex].classList.add(styles.active)
	}

	if(tickers[previousIndex]){
		tickers[previousIndex].classList.add(styles.completed)
		tickers[previousIndex].classList.remove(styles.active)
	}

	if(tickers[nextIndex]){
		tickers[nextIndex].classList.remove(styles.completed)
	}
}

function FrontHero(props) {
	const fields = props.fields
	const contentRef = useRef(null)
	const sliderRef = useRef(null)
	const [visibleIn, setVisibleIn] = useState (0)
	const [visibleOut, setVisibleOut] = useState(0)
	const [scrollPos, setScrollPos] = useState(window.scrollY)
	const { announcementHeight, heightChangeHandler } = useContext(AnnouncementContext)

	const onScroll = () => {
		const topPos = contentRef.current.getBoundingClientRect().top + window.scrollY
		const windowPos = window.scrollY + window.outerHeight

		if (topPos < (windowPos - (window.outerHeight / 8))) {
			setVisibleIn(1)
		}

		if (window.scrollY - announcementHeight > (window.outerHeight / 7.5)) {
			setVisibleOut(1)
		} else {
			setVisibleOut(0)
		}
	
		setScrollPos(window.scrollY)
	}
	
	useEffect(() => {
		onScroll()
		sliderRef.current.swiper.autoplay.stop()

		setTimeout(() => {
			sliderRef.current.swiper.autoplay.start()
		}, 3000)

		window.addEventListener('scroll', onScroll)
		return () => window.removeEventListener('scroll', onScroll)
	}, [announcementHeight])

	return <BlockWrapper id='front_hero' {...props} className={classNames(styles.front_hero, props.editor ? styles.editor : '')} style={{marginTop: announcementHeight + 'px', marginBottom: '0px'}}>
		<ScrollAnimation styles={styles}>
			<Swiper ref={sliderRef} className={styles.hero_slider}
				modules={[Autoplay, EffectFade]}
				autoplay={{ delay: 2000 }}
				slidesPerView={1}
				loop={true}
				effect="fade"
				fadeEffect={{crossFade: true}}
				speed={3000}
				onSlideChange={(swiper) => updateTicker(swiper.realIndex)}
			>
				{fields.slides.map((slide, index) => {
					return <SwiperSlide className={styles.hero_slide} key={index}>
						<Media className={styles.image} settings={{texture: false, loading: (index == 0 ? 'eager' : 'lazy')}} {...slide.media} />
					</SwiperSlide>
				})}
			</Swiper>
			<div className={styles.hero_texture}></div>
			<div className={styles.hero_overlay}></div>
			<div className={classNames(styles.hero_content, visibleIn ? styles.animate_in : '', visibleOut ? styles.animate_out : '')}>
				<div ref={contentRef} className={styles.hero_text_wrapper}>
					<div className={styles.ticker_wrapper}>
						<ul className={styles.ticker}>
							{fields.ticker.map((slide, index) => {
								return <li className={styles.ticker_slide} key={index}>
									<span className={classNames(styles.h1, styles.ticker_text)}>{slide.text}</span>
								</li>
							})}
						</ul>
					</div>
					<div className={styles.hero_text}>
						<h1>{fields.hero_text}</h1>
					</div>
				</div>
				<div className={styles.scroll_down}>
					<a onClick={e => {
						let anchor = document.getElementById("anchor")
						e.preventDefault()
						anchor && anchor.scrollIntoView({ behavior: "smooth", block: "start"})
						}}
					>
					</a>
				</div>
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default FrontHero